<template>
	<v-container>
		<v-card background-color="transparent" elevation="0" >
			<v-data-table :loading="recentOptions.loading" theme-- light :headers="headers" :items="recentOptions.data"
				:items-per-page="recentOptions.limit" :server-items-length="recentOptions.total"
				:options.sync="recentOptions.options" class="light table mx-4 assessed-table"
				:footer-props="{ 'items-per-page-options': [10, 15, 20] }">
				<template v-slot:item.id="{ item }">
					<router-link :to="{ name: `Transaction Details`, params: { id: item.id } }">{{ item.id }}</router-link>
				</template>
				<template v-slot:item.timestamp="{ item }">
					{{ item.timestamp | moment("DD.MM.YYYY h:mm:ss") }}
				</template>
				<template v-slot:item.status="{ item }">
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<p class="mx-2 my-0" :style="{ color: item.status.color }" v-bind="attrs" v-on="on">
								<v-icon small :style="{ color: item.status.color }">fas fa-{{ item.status.icon }}</v-icon>
								{{ item.status.description_short }}
							</p>
						</template>
					</v-tooltip>
				</template>
				<template v-slot:item.blockchainStatus="{ item }">
					<a v-if="item.block !== 'Awaiting validification'"
						:href="'http://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{ item.block }}</a>
					<p class="my-0 text-left font-italic" v-if="item.block === 'Awaiting validification'">{{ item.block }}
					</p>
				</template>
			</v-data-table>
			<br />
			<br />
			<br />
			<v-col  class="darkColor--text">
				<h4 v-if="!recentOptions.data">None of your suppliers have answered sustainability. </h4>
				<p>Invite your suppliers to fill out the sustainability Forum - </p>
				<v-btn class="selfassementbtn" to="/csr/request" elevation="0" style="color: orange; background-color: transparent;"><u>Send invitation to your suppliers to fill out</u></v-btn>
			</v-col>
		</v-card>
	</v-container>
</template>

<script>
//import TransactionAPI from "../api/trace/transaction"
//import LoadingState from "../consts/LoadingState"
export default {
	name: "SelfAssessment",

	data() {
		return {
			recentOptions: {
				limit: 10,
				offset: 0,
				total: 0,
				data: [],
				loading: true,
				options: {},
			},
			headers: [
				{
					text: "Supplier",
					align: "start",
					sortable: false,
					value: "id",
					class: "secondary--text",
					style: "color: red"
				},
				{
					text: "Their Score",
					value: "timestamp",
					sortable: false,
					class: "secondary--text",
					style: "color: red"
				},
				{
					text: "Importance of Suppliers",
					value: "recipientordernumber",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Supply chain score",
					value: "sender",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Suppliers",
					value: "status",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Impact",
					value: "blockchainStatus",
					sortable: false,
					class: "secondary--text"
				}
			],
			deleteDialog: false,
			selectedDraftID: null,
		}
	},
	mounted() {
		this.getRecentTransaction()
	},
	watch: {
		"recentOptions.options": {
			handler() {
				//if user select all
				if (this.recentOptions.options.itemsPerPage === -1) {
					this.recentOptions.options.itemsPerPage = this.recentOptions.total
				}
				this.recentOptions.offset = (this.recentOptions.options?.page - 1) * this.recentOptions.options?.itemsPerPage
				this.recentOptions.limit = this.recentOptions.options?.itemsPerPage
				this.getRecentTransaction()
			},
			deep: true,
		},
	},
	methods: {
		// getRecentTransaction() {
		// 	this.recentOptions.loading = true
		// 	TransactionAPI.getTransactionList(this.recentOptions.limit, this.recentOptions.offset, 2)
		// 		.then(data => {
		// 			this.recentOptions.total = data?.metadata?.pagination?.totalRecords
		// 			this.recentOptions.data = data?.data
		// 			this.recentOptions.loading = false
		// 		})
		// 		.catch(error => {
		// 			this.$store.dispatch(
		// 				"loading/" + LoadingState.ACTION_SET_ERROR,
		// 				error,
		// 				{ root: true }
		// 			)
		// 		})
		// },
		
	}
}
</script>

<style scoped >
.assessed-table {
	border: 1px solid #ddd;

}


.darkColor--text {
	font-weight: bold;
	display: flex;
}

v-btn {
	margin-left: 10px;
	color: orange;
	margin-left: 100px;
	margin-bottom: -100px;
	font-weight: bolder;
}
.btnclasstodirect{
	margin-top: -5px;
	color: orange;
	font-weight: bolder;
}

.selfassementbtn{
	margin-top: -5px;
	font-weight: bolder;
}
</style>